import "./App.css";
import { Route, Routes } from "react-router-dom";
import Home from "./routes/home";
import Home2 from "./routes/home2";
import About from "./routes/about";
import Contact from "./routes/contact";
import Service from "./routes/service";
import 'bootstrap/dist/css/bootstrap.min.css';
import Signup from  "./components/Signup/Signup";
import { auth } from "./firebase";
import React, { useEffect, useState } from "react";
import Login from  "./components/Login/Login";;

export default function App() {
  const [userName, setUserName] = useState("");

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      if (user) {
        setUserName(user.displayName);
        
      } else setUserName("");
    });
  }, []);
  return (
    <div className="App">
      <Routes>
      <Route path="/"element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/service" element={<Service />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
      </Routes>
      
    </div>
  );
}
